module.exports = __webpack_public_path__ + "static/img/case6-bg.798420b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case6-bg.webp
// module id = 5t5g
// module chunks = 0